import { get, isEmpty } from 'lodash';
import { Category } from 'src/types/catalog';
import { TreeViewItem } from 'src/types/TreeView';

export const transformCategoriesToTreeData = (categories: Category[]): TreeViewItem[] => {
  const transformCategory = (category: Category): TreeViewItem => {
    // Transform and sort children alphabetically
    let existingChildren: Category[] = get(category, 'children', []);
    let children: TreeViewItem[] = [];
    if (!isEmpty(existingChildren)) {
      children = existingChildren
        .filter((child) => !child.isDeleted)
        .map((child) => transformCategory(child))
        .sort((a, b) => a.text.localeCompare(b.text));
    }

    return {
      text: category.description,
      id: `category-${category.categoryId}`,
      checked: true,
      expanded: false, // Default state: collapsed
      items: children.length > 0 ? children : undefined,
    };
  };

  // Filter deleted categories, transform, and sort alphabetically
  const transformedCategories: TreeViewItem[] = categories
    .filter((category) => !category.isDeleted)
    .map((category) => transformCategory(category))
    .sort((a: TreeViewItem, b: TreeViewItem) => {
      const aText: string = get(a, 'text', '');
      const bText: string = get(b, 'text', '');
      if (!isEmpty(aText) && !isEmpty(bText)) {
        return aText.localeCompare(bText);
      }
      return 0;
    });
  return [
    {
      text: 'All Categories',
      id: 'all-categories',
      checked: true,
      expanded: false, // Default state: collapsed
      isSelectAll: true,
    },
    ...transformedCategories,
  ];
};
